import type L from 'leaflet';

/** Server ubin peta (satu tempat): VITE_TILE_URL saat build, bawaan OpenStreetMap. */
export const TILE_URL: string =
  (import.meta.env.VITE_TILE_URL as string | undefined) || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

// Titik awal peta bila belum ada data: Pengaturan → Lokasi gudang/kantor (diset sesi dari /api/meta);
// belum diisi → seluruh Indonesia.
let start: { center: [number, number]; zoom: number } = { center: [-2.5, 118], zoom: 5 };
export function configureMap(settings: Record<string, string | undefined>): void {
  const lat = Number(settings.depot_lat);
  const lng = Number(settings.depot_lng);
  start =
    settings.depot_lat && settings.depot_lng && Number.isFinite(lat) && Number.isFinite(lng)
      ? { center: [lat, lng], zoom: 12 }
      : { center: [-2.5, 118], zoom: 5 };
}
export const mapStart = () => start;

/**
 * Bongkar peta Leaflet dengan aman saat halaman ditinggalkan.
 * Animasi zoom (mis. fitBounds) menjadwalkan _onZoomTransitionEnd lewat setTimeout 250 ms; bila peta sudah dihapus
 * sebelum itu (pengguna cepat pindah menu), Leaflet melempar "Cannot read properties of undefined (reading
 * '_leaflet_pos')". Leaflet melewati _onZoomTransitionEnd bila _animatingZoom = false — jadi tandai dulu sebelum remove.
 */
export function destroyMap(map: L.Map): void {
  try {
    map.stop();
    (map as unknown as { _animatingZoom: boolean })._animatingZoom = false;
    map.off();
    map.remove();
  } catch {
    /* peta sudah dibongkar */
  }
}
